<template>
    <div>
        <apexchart type=pie width=400 ref="pieGender" :options="options" :series="series" />
    </div>
</template>

<script>
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts'
Vue.component('apexchart', VueApexCharts)

  export default {
    components: {
        apexcharts: VueApexCharts
    },      
    props: {
        chartDatas: { type: Object, required: false, default: function () { return {}}},
    },
    watch: {
        
 
    chartDatas : {
        deep: true,
        handler(newValue) {            
            var y = newValue.graph_articles_count
            var x =  newValue.graph_articles_id
            this.basechart(x, y) 
        }
    }}, 
    data: function () {
        return {
            numb : [],
            options : {},
            series : []
        }
     },
     methods : {
        basechart(x, y) { 


            this.series = y,
            this.options = {
                labels: x,
                chart : {
                    width: 600,
                    events: {   
                    legendClick: (chartContext, seriesIndex, config)=>{
                        this.$emit('changeArticle', x[seriesIndex])
                    },
                    updated: function(chartContext, config) {
                      console.log(chartContext, config)
                    },
                        markerClick: function(chartContext, { seriesIndex, dataPointIndex, config}) {
      console.log(chartContext, { seriesIndex, dataPointIndex, config})
    }
                  }
                },
                states: {
                    normal: {
                        filter: {
                            type: 'none',
                            value: 0,
                        }
                    },
                    hover: {
                        filter: {
                            type: 'lighten',
                            value: 0.15,
                        }
                    },
                    active: {
                        allowMultipleDataPointsSelection: false,
                        filter: {
                            type: 'darken',
                            value: 0.35,
                        }
                    },
                },
                legend: {
                    position: 'right'
                }       
            }
            try {  
               this.$refs.pieGender.updateSeries(this.series, true);
               this.$refs.pieGender.updateOptions(this.options, false, true);
            } catch (err) {
               console.log(err)
            }
        }
     }
  }
</script>